import { inject, Service } from '@angular/core';
import { EventBusService } from '@shared';
import {
	HeaderConfigurationToHeader,
	HeaderSymbolToHeader,
	SYMBOL_DETAIL_HEADER_EVENTS
} from './symbol-detail-header-events.model';

/**
 * Symbol Detail → Header configuration producer.
 */
@Service({ autoProvided: false })
export class SymbolDetailHeaderEventProducerService {
	private readonly eventBus = inject(EventBusService);

	publishHeaderConfiguration(config?: HeaderConfigurationToHeader): void {
		this.eventBus.dispatch(SYMBOL_DETAIL_HEADER_EVENTS.HEADER_CONFIGURATION, config);
	}

	configureSymbolDetailHeader(symbol?: HeaderSymbolToHeader | null): void {
		this.publishHeaderConfiguration({
			showLogo: false,
			headerRightSectionItems: [{ iconName: 'expanded', eventId: 'back', ariaLabel: 'بازگشت' }],
			symbol: symbol ?? null
		});
	}

	resetHeader(): void {
		this.publishHeaderConfiguration();
	}

	clearEventSnapshot(eventId: string): void {
		this.eventBus.clearSnapshot(SYMBOL_DETAIL_HEADER_EVENTS.HEADER_ACTION, eventId);
	}
}
